import { ROUTE_API } from "constant";
// import { ICreatePostInputMode } from "interfaces";
import apiV3 from "utils/api.v3";

export const FileServices = {
  createFiles,
};

function createFiles(data: FormData) {
  return apiV3.post<any>(
    { url: ROUTE_API.FILE_ROUTE.UPLOAD_MULTIPLE_FILES, data },
    { "Content-Type": "multipart/form-data" }
  );
}
